import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Plan } from '../../planModel';
import { PlanService } from '../../plan.service';
import { UserService } from 'src/app/services/user/user.service';
import * as alertifyjs from 'alertifyjs';

@Component({
  selector: 'app-new-plan-v2',
  templateUrl: './new-plan-v2.component.html',
  styleUrls: ['./new-plan-v2.component.css'],
})
export class NewPlanV2Component implements OnInit, OnDestroy {
  @Output() close = new EventEmitter<any>();
  plan: any;
  isLoading = false;
  filterType: any;
  typeInvoice: any;
  shopList = '';
  filters: any;
  terms: any;
  isActive = false;
  accordioncontroller = [true, true, true, true, true, true, true, true];
  shops: any = [];
  shopsForPayload: any = [];
  dynamicCodeList: any = [];
  codeList: any = [];
  auxList: any = [];
  auxList2: any = [];
  auxList3: any = [];
  filterText: string = '';
  filterText2: string = '';
  filterText3: string = '';
  showListStores = false;
  showListCodes = false;
  showListCodes2 = false;
  multiproductCodeList:any [] = [];
  selectedCode = ''
  //formTerms = false;
  btnTitle = 'Agregar Plan';
  errorControls: any = {
    errorCode: false,
    errorInitDate: false,
    errorEndDate: false,
    errorDescription: false,
    errorVisualization: false,
    errorQuotaMin: false,
    errorQuotaMax: false,
    errorInitialType: false,
    errorInitialAmount: false,
    errorMinAmountBase: false,
    errorMaxAmountBase: false,
    errorMinAmountToPay: false,
    errorPaymentTermsInstallment: false,
    errorfrequencyType: false,
    errorInstallmentDays: false,
    errorFilterType: false,
    errorAudienceType: false,
    errorShopType: false,
    errorShopList: false,
    errorCodeList: false,
    errorCodeList2: false,
    errorPriority: false,
    errorProduct_type: false,
    errorRemanenteAmount: false,
    errorNeteoAmount: false
    //errorFormTerms: false,
  };
  canEdit = true;
  globalError = false;
  configHistoryChange = false;
  electronicBill = true;
  weekendAmounts = true;
  today = today.toISOString().split('T')[0];
  filterText3Selected = ''
  showFilterText3Selected = false

  quota:boolean = true;
  quotaFrecuency:any;
  statusInitial:boolean = true;
  messageZero:any;
  isModalOpen:boolean = false;

  productArray:any[] = [];
  productSelected:any;
  itemProduct:any[] = [];

  // Propiedades para propuestas de seguros
  insuranceProposals: any[] = [];
  selectedProposal: string = '';
  showInsuranceProposals: boolean = false;
  selectedProductInsuranceConfig: any = null;

  iconPlan:any;

  // Nuevas variables para Códigos dinámicos2 (other)
  dynamicCodeList2: any = [];
  codeList2: any = [];
  auxList4: any = [];
  filterText4: string = '';
  showListCodes3 = false;

  constructor(private _planService: PlanService, private _user: UserService) {
    let examplePlan = DEFAULT_PLAN_DATA;
    sessionStorage.setItem('DEFAULT_PLAN_DATA', JSON.stringify(DEFAULT_PLAN_DATA))
    sessionStorage.setItem('defaultFilter', JSON.stringify(defaultFilter))
    sessionStorage.setItem('defaultTerms', JSON.stringify(defaultTerms))
    let exampleFilter = defaultFilter;
    let exampleTerms = defaultTerms;
    this.plan = examplePlan;
    this.filters = exampleFilter;
    this.terms = exampleTerms;
  }

  ngOnInit(): void {
    this.getshops();
    this.getCodes();
    this.consultAllProductsInvoices();
    this.getMultiProductCodes();

    // 🔧 DEBUG: Probar endpoints de seguros automáticamente
    setTimeout(() => {
      this.testInsuranceEndpoints();
    }, 2000);

    if (this._planService.selectedPlan) {
      this.setPlanInfo();
    } else {
      this.cleanFormData(true);
    }
    this.changeQuota(this.terms.installments, this.plan.initial.status);
  }

  getMultiProductCodes() {
    this._planService.getMultiProductCode().subscribe(
      (data: any)=>{
        this.multiproductCodeList = data.res;
        console.log('nuevos codes',this.multiproductCodeList)
      },  error =>{
        console.log(error);
      }
    )
  }

  ngOnDestroy() {
    this.cleanFormData();
  }

  setPlanInfo() {
    this.terms.installments = '';
    this.plan = this._planService.selectedPlan;

    this.plan.payment_terms.forEach((term: any, index: number) => {
      if (index < this.plan.payment_terms.length - 1) {
        this.terms.installments =
          this.terms.installments + term.installments + ', ';
      } else {
        this.terms.installments = this.terms.installments + term.installments;
      }
    });

    this.terms.frequency.type = this.plan.payment_terms[0].frequency.type;
    this.validateVersions();
    this._planService.selectedPlan = null;
    console.log(this.plan);
    this.canEdit = false;
    this.btnTitle = 'Actualizar Plan';
    if (this.plan.visibility == 'PUBLIC') {
      this.plan.visibility = 'Público';
    } else {
      this.plan.visibility = 'Privado';
    }

    // Si estamos editando, verificar si el producto es de seguros y cargar propuestas
    if (this.plan.params.product_type) {
      this.productSelected = this.plan.params.product_type;
      this.checkAndLoadInsuranceProposalsForEdit();
    }

    if (this.plan.params.end_date) {
      this.plan.params.end_date = this.plan.params.end_date
        .toString()
        .substring(0, 10);
    }

    if (this.plan.params.init_date) {
      this.plan.params.init_date = this.plan.params.init_date
        .toString()
        .substring(0, 10);
    }

    if (this.plan.initial.type == 'percentage') {
      this.plan.initial.type = 'Porcentaje';
    } else {
      this.plan.initial.type = 'Valor fijo';
    }

    if (this.plan.params.filters.general.person.audience == 'NATURAL') {
      this.plan.params.filters.general.person.audience = 'Persona natural';
    } else {
      this.plan.params.filters.general.person.audience = 'Persona jurídica';
    }

    if (this.plan.params.filters.dinamic_code.person.type == 'white_list') {
      this.plan.params.filters.dinamic_code.person.type = 'Lista blanca';
    } else {
      this.plan.params.filters.dinamic_code.person.type = 'Lista negra';
    }

    this.auxList = this.plan.params.filters.dinamic_code.person.list;

    if (this.plan.params.filters.shop) {
      if (this.plan.params.filters.shop.person.type == 'white_list') {
        this.plan.params.filters.shop.person.type = 'Lista blanca';
      } else {
        this.plan.params.filters.shop.person.type = 'Lista negra';
      }
      this.auxList2 = this.plan.params.filters.shop.person.list;
    }

    if (this.plan.params.filters.multiproduct_code) {
      if (this.plan.params.filters.multiproduct_code.person.type == 'white_list') {
        this.plan.params.filters.multiproduct_code.person.type = 'Lista blanca';
      } else {
        this.plan.params.filters.multiproduct_code.person.type = 'Lista negra';
      }
      this.auxList4 = this.plan.params.filters.multiproduct_code.person.list;
    }

    // Inicializar campos nuevos si no existen
    if (!this.plan.params.remanente) {
      this.plan.params.remanente = {
        status: false,
        amount: 0
      };
    }

    if (!this.plan.params.neteo) {
      this.plan.params.neteo = {
        status: false,
        amount: 0
      };
    }

    // Asegurar que weekday esté inicializado solo si no existe
    if (this.plan.params.weekday === undefined) {
      this.plan.params.weekday = false;
    }
  }

  validateVersions() {
    if (this.plan.version_change.length > 0) {
      this.plan.version_change.forEach((item: any) => {
        Object.defineProperty(item, 'showSubItems', {
          value: false,
          writable: true,
        });
      });

      this.plan.version_change = this.plan.version_change.reverse();
    }
  }

  showHistorydetails(item: any) {
    this.plan.version_change.forEach((element: any) => {
      if (element.version.internal_code == item.version.internal_code) {
        element.showSubItems = !element.showSubItems;
      }
    });
  }

  evaluateFilterType(event: any) {}
  resetErrorControllers() {
    this.errorControls = {
      errorName: false,
      errorCode: false,
      errorInitDate: false,
      errorEndDate: false,
      errorDescription: false,
      errorVisualization: false,
      errorQuotaMin: false,
      errorQuotaMax: false,
      errorInitialType: false,
      errorInitialAmount: false,
      errorMinAmountBase: false,
      errorMaxAmountBase: false,
      errorMinAmountToPay: false,
      errorPaymentTermsInstallment: false,
      errorfrequencyType: false,
      errorInstallmentDays: false,
      errorFilterType: false,
      errorAudienceType: false,
      errorShopType: false,
      errorShopList: false,
      errorCodeList: false,
      errorCodeList2: false,
      errorPriority: false,
      errorZero: false,
      errorFieldsEmpty: false,
      errorPorcentajeCien: false,
      errorRemanenteAmount: false,
      errorNeteoAmount: false
      //errorFormTerms: false,
    };
    this.globalError = false;
  }

  validateFields() {
    let errorFinded = false;
    this.resetErrorControllers();

    if (!this.plan.name) {
        this.errorControls.errorName = true;
        errorFinded = true;
    }

    if (!this.plan.code) {
        this.errorControls.errorCode = true;
        errorFinded = true;
    }

    if (!this.plan.params.init_date) {
        this.errorControls.errorInitDate = true;
        errorFinded = true;
    }

    if (!this.plan.description) {
        this.errorControls.errorDescription = true;
        errorFinded = true;
    }

    if (!this.plan.visibility) {
        this.errorControls.errorVisualization = true;
        errorFinded = true;
    }

    if (!this.plan.params.current_quota_min) {
        this.errorControls.errorQuotaMin = true;
        errorFinded = true;
    }

    if (!this.plan.params.current_quota_max) {
        this.errorControls.errorQuotaMax = true;
        errorFinded = true;
    }

    if (!this.plan.initial?.type && this.plan.initial?.status) {
        this.errorControls.errorInitialType = true;
        errorFinded = true;
    }

    if (!this.plan.initial?.amount && this.plan.initial?.status) {
        this.errorControls.errorInitialAmount = true;
        errorFinded = true;
    }

    const initialAmount = Number(this.plan.initial?.amount);
    const hasInstallments = !!this.terms.installments && this.terms.installments.trim() !== '';
    const installmentsValue = hasInstallments ? Number(this.terms.installments) : 0;

    if (this.plan.initial?.status && initialAmount !== 100) {
        if (!this.plan.params.min_amount) {
            this.errorControls.errorMinAmountToPay = true;
            errorFinded = true;
        }

        if (!this.plan.params.min_amount_base) {
            this.errorControls.errorMinAmountBase = true;
            errorFinded = true;
        }

        if (!this.plan.params.max_amount_base || Number(this.plan.params.max_amount_base) < Number(this.plan.params.min_amount_base)) {
            this.errorControls.errorMaxAmountBase = true;
            errorFinded = true;
        }
    }

    if (!this.plan.params.product_type) {
        this.errorControls.errorProduct_type = true;
        errorFinded = true;
    }

    if (this.plan.initial?.status) {
        if (initialAmount < 100) {
            if (!hasInstallments) {
                this.errorControls.errorFieldsEmpty = true;
                this.messageZero = true;
                errorFinded = true;
            } else if (installmentsValue === 0) {
                this.errorControls.errorZero = true;
                this.messageZero = true;
                errorFinded = true;
            }
            if (installmentsValue > 0 && !this.terms.frequency.type) {
                this.errorControls.errorfrequencyType = true;
                errorFinded = true;
            }
        }
    } else {
        if (!hasInstallments || installmentsValue === 0) {
            this.errorControls.errorFieldsEmpty = true;
            this.messageZero = true;
            errorFinded = true;
        } else {
            this.quotaFrecuency = false;
            this.quota = true;
            if (!this.terms.frequency.type) {
                this.errorControls.errorfrequencyType = true;
                errorFinded = true;
            }
        }
    }

    if (this.plan.params?.end_date < this.plan.params.init_date) {
        delete this.plan.params?.end_date;
        this.errorControls.errorEndDate = true;
        errorFinded = true;
    }

    if ((this.plan.params?.priority === undefined || this.plan.params?.priority === null) &&
        this.plan.params?.multiple_invoices?.status) {
        this.errorControls.errorPriority = true;
        errorFinded = true;
    }

    // Validación para Remanente
    if (this.plan.params.remanente.status &&
        (!this.plan.params.remanente.amount || Number(this.plan.params.remanente.amount) <= 0)) {
        this.errorControls.errorRemanenteAmount = true;
        errorFinded = true;
    }

    // Validación para Neteo
    if (this.plan.params.neteo.status &&
        (!this.plan.params.neteo.amount || Number(this.plan.params.neteo.amount) <= 0)) {
        this.errorControls.errorNeteoAmount = true;
        errorFinded = true;
    }

    if (errorFinded) {
        this.showAllItems();
        return;
    }

    this.bindComplexElements();
}



  showAllItems() {
    this.globalError = true;
    this.accordioncontroller = [true, true, true, true, true, true, true, true];
  }

  bindComplexElements() {
    if (this.plan.visibility == '1') {
      this.plan.visibility = 'PUBLIC';
    } else {
      this.plan.visibility = 'PRIVATE';
    }

    if (this.plan.initial.type == '1') {
      this.plan.initial.type = 'percentage';
    } else {
      this.plan.initial.type = 'amount';
    }

    if (this.filters.general?.invoices?.shop?.type == '1') {
      this.filters.general.invoices.shop.type = 'white_list';
    } else {
      this.filters.general.invoices.shop.type = 'black_list';
    }

    if (this.filters.dinamic_code.person.type == '1') {
      this.filters.dinamic_code.person.type = 'white_list';
    } else {
      this.filters.dinamic_code.person.type = 'black_list';
    }

    // Agregar lógica para dinamic_code.other
    if (this.filters.dinamic_code?.other?.type == '1') {
      this.filters.dinamic_code.other.type = 'white_list';
    } else if (this.filters.dinamic_code?.other?.type == '2') {
      this.filters.dinamic_code.other.type = 'black_list';
    }

    if (this.shopsForPayload.length > 0) {
      this.filters.general.invoices.shop.list = []
      this.shopsForPayload.forEach((item: any) => {
        if (item.code) {
          this.filters.general.invoices.shop.list.push(item.code);
        }
      });
    }

    if (this.codeList.length > 0) {
      this.filters.dinamic_code.person.list = []
      this.codeList.forEach((item: any) => {
        if (item.code) {
          this.filters.dinamic_code.person.list.push(item.code);
        }
      });
    }

    // Agregar lógica para codeList2 (dinamic_code.other)
    if (this.codeList2.length > 0) {
      this.filters.dinamic_code.other.list = []
      this.codeList2.forEach((item: any) => {
        if (item.code) {
          this.filters.dinamic_code.other.list.push(item.code);
        }
      });
    }

    this.plan.version.name = this.plan.name;
    this.plan.version.description = this.plan.description;

    this.plan.payment_terms = [];
    let termsList = this.terms.installments.toString().split(',');
    termsList.forEach((item: string) => {
      this.plan.payment_terms.push({
        code: this.plan.code + '_' + item,
        frequency:
          this.terms.frequency.type == 'dias_continuos'
            ? this.terms.frequency
            : { type: this.terms.frequency.type },
        name: this.getTermsName(Number(item.trim())), //'cuota pagada en ' + this.terms.frequency.type + ' ' + item,
        order: this.terms.order,
        installments: Number(item.trim()),
      });
    });

    if (this.filterType == 1) {
      let filters = {
        general: {
          person: {
            audience: this.filters.general?.person?.audience || 'NATURAL',
          },
        },
      };
      this.filters.general = filters.general;
    }

    if (this.filterType == 2) {
      let filters = {
        general: {
          invoices: {
            category: this.filters.general.invoices.category,
            shop: {
              type: this.filters.general.invoices.shop.type,
              list: this.filters.general.invoices.shop.list,
            },
          },
        },
      };
      this.filters.general = filters.general;
    }

    this.plan.params.filters = this.filters;


    if (this.plan.params?.filters?.dinamic_code?.person?.list?.length < 1) {
      delete this.plan.params.filters.dinamic_code;
    }

    // Validar dinamic_code.other
    if (this.plan.params?.filters?.dinamic_code?.other?.list?.length < 1) {
      if (this.plan.params?.filters?.dinamic_code?.other) {
        delete this.plan.params.filters.dinamic_code.other;
      }
    }

    // Si tanto person como other están vacías o no existen, eliminar dinamic_code completamente
    const hasPersonCodes = this.plan.params?.filters?.dinamic_code?.person?.list?.length > 0;
    const hasOtherCodes = this.plan.params?.filters?.dinamic_code?.other?.list?.length > 0;

    if (!hasPersonCodes && !hasOtherCodes) {
      delete this.plan.params.filters.dinamic_code;
    }

    if (this.plan.params?.filters?.general?.invoices?.shop?.list?.length < 1) {
      delete this.plan.params.filters.general.invoices;
    }

    if(this.plan.params?.end_date == '' ){
      delete this.plan.params.end_date
    };
    this.plan.params.current_quota_min  = parseFloat(this.plan?.params?.current_quota_min);
    this.plan.params.current_quota_max  = parseFloat(this.plan?.params?.current_quota_max);
    this.plan.params.multiple_invoices.count = parseFloat(this.plan?.params?.multiple_invoices?.count);
    this.plan.params.priority = parseFloat(this.plan?.params?.priority);
    this.plan.initial.amount = parseFloat(this.plan?.initial?.amount);
    this.plan.params.min_amount = parseFloat(this.plan?.params?.min_amount);
    this.plan.params.min_amount_base = parseFloat(
      this.plan?.params?.min_amount_base
    );
    this.plan.params.max_amount_base = parseFloat(
      this.plan?.params?.max_amount_base
    );

    if(this.plan.status){
      this.plan.state = 'ACTIVE';
    }else{
      this.plan.state = 'INACTIVE';


    }

    // Debug: Mostrar el valor de weekday después de las transformaciones
    console.log('GEMINI DEBUG: Valor de weekday después de bindComplexElements:', this.plan.params.weekday);

    if (this.btnTitle == 'Agregar Plan') {
      this.createPlan();
    } else {
      this.updatePlan();
    }
  }

  getTermsName(index: number) {
    //'cuota pagada en ' + this.terms.frequency.type + ' ' + item,
    if (index == 1) {
      return 'Una cuota unica pagada en 1' + this.getType(index);
    } else {
      return index + ' cuotas pagadas ' + this.getType(index);
    }
  }

  getType(index: number) {
    if (index > 1) {
      if (this.terms.frequency.type == 'mes') {
        return 'mensualmente';
      } else if (this.terms.frequency.type == 'semana') {
        return 'semanalmente';
      } else {
        return this.terms.frequency.type;
      }
    } else {
      if (this.terms.frequency.type == 'dias') {
        return 'dia';
      } else {
        return this.terms.frequency.type;
      }
    }
  }

  updateFilters() {
    if (this.shopList) {
      this.filters.general.invoices.shop.list = this.shopList.split(' ');
    }
  }

  updateTerms() {
    this.plan.payment_terms[0] = this.terms;
  }

  validateDates() {
    if (this.plan.params.init_date > this.plan.params?.end_date) {
      this.plan.params.end_date = today.toISOString().split('T')[0];
      console.log(
        'error la fecha de inicio no puede ser mayor que la fecha de finalizacion'
      );
    }
  }

  createPlan() {
    this.isLoading = true;

    this.plan.params.icon = this.plan.params.icon;

    // Incluir la propuesta seleccionada si existe
    if (this.selectedProposal) {
      this.plan.params.insurance_proposal = this.selectedProposal;
    }

    this._planService.createPlan(this.plan).subscribe(
      (data: any) => {
        this.isLoading = false;
        console.log(data);
        // ELIMINADO: window.location.href = window.location.href; - No recargar página
        alertifyjs.success('Plan creado exitosamente');
        this.cleanFormData();
      },
      (error) => {
        this.isLoading = false;
        console.log(error);
        alertifyjs.error('Error al crear el plan');
      }
    );
  }

  updatePlan = async () => {

    this.isLoading = true;

    // Incluir la propuesta seleccionada si existe
    if (this.selectedProposal) {
      this.plan.params.insurance_proposal = this.selectedProposal;
    }

    // Debug: Mostrar el valor de weekday antes de enviar
    console.log('GEMINI DEBUG: Valor de weekday antes de enviar:', this.plan.params.weekday);
    console.log('GEMINI DEBUG: Plan completo antes de enviar:', JSON.stringify(this.plan, null, 2));

    try {

     let data =  await  this._planService.updatePlan(this.plan);

      this.isLoading = false;
      console.log(data);

      // ELIMINADO: window.location.href = window.location.href; - No recargar página
      alertifyjs.success('Plan actualizado exitosamente');
      this.cleanFormData();
    } catch (error) {

      this.isLoading = false;
      console.log(error);
      alertifyjs.error('Error al actualizar el plan');
    }

  }

  mangeAccordion(index: number) {
    this.accordioncontroller.forEach((item: boolean, i: number) => {
      if (i == index) {
        this.accordioncontroller[i] = !this.accordioncontroller[i];
      }
    });
  }

  getCodes() {
    this.dynamicCodeList = [];
    this.codeList = [];
    this.auxList2 = [];
    // Agregar reset de variables para códigos dinámicos2
    this.dynamicCodeList2 = [];
    this.codeList2 = [];
    this.auxList4 = [];

    this._planService.getCodes().subscribe(
      (data: any) => {
        console.log(data);

        // Filtrar códigos de persona (solo category: "person")
        this.dynamicCodeList = data.data.filter((item: any) => item.category === 'person');

        // Filtrar códigos "other" (todos excepto category: "person")
        this.dynamicCodeList2 = data.data.filter((item: any) => item.category !== 'person');

        // Inicializar las listas auxiliares con los códigos filtrados
        this.auxList2 = this.dynamicCodeList;
        this.auxList4 = this.dynamicCodeList2;

        if (this.plan.params?.filters?.dinamic_code?.person?.list?.length > 0) {
          this.plan.params.filters.dinamic_code.person.list.forEach(
            (item: any) => {
              this.dynamicCodeList.forEach((code: any) => {
                if (code.code == item) {
                  this.codeList.push(code);
                }
              });
            }
          );
        }

        // Llenar también codeList2 si hay datos en dinamic_code.other
        if (this.plan.params?.filters?.dinamic_code?.other?.list?.length > 0) {
          this.plan.params.filters.dinamic_code.other.list.forEach(
            (item: any) => {
              this.dynamicCodeList2.forEach((code: any) => {
                if (code.code == item) {
                  this.codeList2.push(code);
                }
              });
            }
          );
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  async getshops() {
    try {
      const resp = await this.getshopsServer();
      this.shops = resp?.res;
      if (this.filterType == '2') {
        const codeList = this.plan.params.filters.general.invoices.shop.list;

        this.shops.forEach((item: any) => {
          codeList.forEach((id: string) => {
            if (item.code == id) {

              this.shopsForPayload.push(item);
            }
          });
        });
      }
      let obj_shop: any = {};
      this.shops?.map((item: any) => {
        obj_shop[item.code] = item;
      });
    } catch (error) {
      console.error(error);
    }
  }

  async getshopsServer() {
    try {
      return this._user.getshops({});
    } catch (error) {
      console.error(error);
    }
  }

  filteredItems() {
    if (this.filterText) {
      this.auxList = this.shops.filter((item: any) =>
        item.name.toLowerCase().includes(this.filterText.toLowerCase())
      );
    } else {
      this.auxList = this.shops;
    }
  }

  filteredItems2() {
    if (this.filterText2) {
      // Mantener el filtrado por categoría "person" y aplicar el filtro de texto
      this.auxList2 = this.dynamicCodeList.filter((item: any) =>
        item.category === 'person' && item.code.toLowerCase().includes(this.filterText2.toLowerCase())
      );
    } else {
      // Solo códigos con categoría "person"
      this.auxList2 = this.dynamicCodeList;
    }
  }

  filteredItems3() {
    if (this.filterText3) {
      this.auxList3 = this.multiproductCodeList.filter((item: any) =>
        item.type.toLowerCase().includes(this.filterText3.toLowerCase())
      );
    } else {
      this.auxList3 = this.multiproductCodeList;
    }
  }

  selectItem(item: any) {
    this.showListStores = false;
    const found = this.shopsForPayload.find(
      (element: any) =>
        element.name.toString().toLowerCase() ==
        item.name.toString().toLowerCase()
    );

    if (!found) {
      this.shopsForPayload.push(item);
    }
  }

  deletItem(item: any) {
    this.shopsForPayload.forEach((elemnt: any, index: number) => {
      if (
        elemnt.name.toString().toLowerCase() ==
        item.name.toString().toLowerCase()
      ) {
        this.shopsForPayload.splice(index, 1);
      }
    });
  }

  selectItem2(item: any) {
    this.showListCodes = false;
    const found = this.codeList.find(
      (element: any) =>
        element.code.toString().toLowerCase() ==
        item.code.toString().toLowerCase()
    );

    if (!found) {
      this.codeList.push(item);
    }
  }

  deletItem2(item: any) {
    this.codeList.forEach((elemnt: any, index: number) => {
      if (
        elemnt.code.toString().toLowerCase() ==
        item.code.toString().toLowerCase()
      ) {
        this.codeList.splice(index, 1);
      }
    });
  }

  selectItem3(item: any) {
    this.plan.params.product_type = item.code
    const type_product = item?.name;
    this.filterText3Selected = `${item.code} - ${type_product}`
    this.showFilterText3Selected = true
    this.showListCodes2 = false

  }

  toggleCodeSearch(){
    this.showFilterText3Selected = false
    this.showListCodes2 = true
    this.filterText3 = ''
    this.filterText3Selected =''
  }


  showList() {
    this.showListStores = !this.showListStores;
  }

  cleanFormData(isInit = false) {
    let examplePlan = JSON.parse(sessionStorage.getItem('DEFAULT_PLAN_DATA')?? '{}');
    let exampleFilter = JSON.parse(sessionStorage.getItem('defaultFilter')?? '{}');;
    let exampleTerms = JSON.parse(sessionStorage.getItem('defaultTerms')?? '{}');;
    this.plan = examplePlan;
    this.filters = exampleFilter;
    this.terms = exampleTerms;
    this.shops = [];
    this.shopsForPayload = [];
    this.dynamicCodeList = [];
    this.codeList = [];
    this.auxList = [];
    this.auxList2 = [];
    this.filterText = '';
    this.filterText2 = '';
    this.showListStores = false;
    this.showListCodes = false;

    // Limpiar también las nuevas variables de códigos dinámicos2
    this.dynamicCodeList2 = [];
    this.codeList2 = [];
    this.auxList4 = [];
    this.filterText4 = '';
    this.showListCodes3 = false;

    // Limpiar configuración de seguros
    this.resetInsuranceProposals();

    //this.formTerms = false;
    this.resetErrorControllers();
    if (!isInit) {
      this.close.emit(true);
    }
  }

  validateMinAmount() {
    this.errorControls.errorMinAmountToPay = false;
    this.errorControls.errorMinAmountBase = false;

    if (this.plan.params.min_amount) {
      if (this.plan.initial.type == '2') {
         // this.plan.params.min_amount > this.plan.initial.amount
         // this.plan.params.min_amount_base > this.plan.initial.amount
         //plan.params.min_amount > this.plan.initial.amount
         if (Number(this.plan.initial.amount) >= Number(this.plan.params.min_amount)) {
          this.errorControls.errorMinAmountToPay = true;
         }
         if ( Number(this.plan.params.min_amount_base) < Number(this.plan.initial.amount)) {
          this.errorControls.errorMinAmountBase = true;
         }

      } else {

        this.plan.params.min_amount_base =
          this.plan.params.min_amount -
          this.toFixedApp(
            this.plan.params.min_amount *
              this.toFixedApp(this.plan.initial.amount / 100)
          );
      }
    }

    if (this.plan.params.min_amount_base > this.plan.params.max_amount_base) {
      //this.plan.params.max_amount_base = Number(this.plan.params.min_amount) + 10;
    }
  }

  cleanInitialAmount() {
    this.plan.initial.amount = 0;
    this.plan.params.min_amount = 0;
    this.plan.params.min_amount_base  = 0;
    this.plan.params.max_amount_base =0
  }

  validateMaxAmount() {
    this.errorControls.errorMaxAmountBase = false;
    if (Number(this.plan.params.max_amount_base) < Number(this.plan.params.min_amount_base)) {
      this.errorControls.errorMaxAmountBase = true;
    }


  }

  toFixedApp = (amount: any) => {
    let a: any = `e+${2}`;
    let b: any = `e-${2}`;
    return +(Math.round(amount + a) + b);
  };


  changeQuota(value: any, status: any): void {
    let valueNumber = parseInt(value, 10);

    if (status) {
      this.messageZero = false;
      if (value === '') {
        this.quotaFrecuency = true;
        this.quota = false;
      } else {
        this.quotaFrecuency = false;
        this.quota = valueNumber !== 0;
      }
    } else {
      if (value === '' || valueNumber === 0) {
        this.messageZero = true;
        this.quota = false;
      } else {
        this.messageZero = false;
        this.quotaFrecuency = false;
        this.quota = true;
      }
    }
  }


  toggleModal() {
    this.isModalOpen = !this.isModalOpen;
  }

  onCodeAdded() {
    this.getMultiProductCodes();
  }

  validateInitialQuota(): boolean {
    if (this.plan.initial.status &&
        this.plan.initial.type === '1' &&
        this.plan.initial.amount < 100 &&
        Number(this.terms.installments) === 0) {
      this.errorControls.errorInitialAmount = true;
      return false;
    }
    return true;
  }


  async selectProductInvoice(event:Event) {
    const target = event.target as HTMLSelectElement;
    const selectProductItem = target.value;

    this.productSelected = selectProductItem;

    let params = {
      code: this.productSelected
    }

    let result = await this._user.getProductsInvoicesFilter(params);

    if(result.resp.length == 0){
      this.itemProduct = [];
      this.resetInsuranceProposals();
      return;
    }

    let resultProducts = result?.resp;
    let element;

    for (let i = 0; i < resultProducts.length; i++) {
      element = resultProducts[i];
    }

    this.itemProduct = element?.params?.products;

    // Verificar si el producto seleccionado es de seguros y cargar propuestas
    await this.checkAndLoadInsuranceProposals(element);
  }

  private async checkAndLoadInsuranceProposals(productElement: any) {
    try {
      console.log('🔍 Verificando configuración de seguros para producto:', this.productSelected);

      // Obtener la configuración completa del producto para verificar si es de seguros
      const productConfig = await this._user.getRemanenteNeteo(this.productSelected);
      console.log('📋 Configuración del producto recibida:', productConfig);

      if (productConfig && productConfig.insurance && productConfig.insurance.is_insurance_product) {
        console.log('✅ Producto ES de seguros:', productConfig.insurance);
        this.selectedProductInsuranceConfig = productConfig.insurance;
        await this.loadInsuranceProposals(this.productSelected);
        this.showInsuranceProposals = true;
        console.log('✅ Select de propuestas mostrado');
      } else {
        console.log('❌ Producto NO es de seguros o no tiene configuración');
        console.log('Configuración insurance:', productConfig?.insurance);
        this.resetInsuranceProposals();
      }
    } catch (error) {
      console.error('❌ Error verificando configuración de seguros:', error);
      this.resetInsuranceProposals();
    }
  }

  private async loadInsuranceProposals(productCode: string) {
    try {
      console.log('🚀 Cargando propuestas para producto:', productCode);
      const response = await this._user.getInsuranceProposals(productCode);
      console.log('📦 Propuestas recibidas:', response);

      if (response && response.resp) {
        this.insuranceProposals = response.resp;
        console.log('✅ Propuestas cargadas desde response.resp:', this.insuranceProposals.length, 'items');
      } else if (response && response.data) {
        this.insuranceProposals = response.data;
        console.log('✅ Propuestas cargadas desde response.data:', this.insuranceProposals.length, 'items');
      } else if (Array.isArray(response)) {
        this.insuranceProposals = response;
        console.log('✅ Propuestas cargadas como array:', this.insuranceProposals.length, 'items');
      } else {
        console.log('⚠️ No se encontraron propuestas en la respuesta');
        this.insuranceProposals = [];
      }

      console.log('📋 Lista final de propuestas:', this.insuranceProposals);
    } catch (error) {
      console.error('❌ Error cargando propuestas:', error);
      this.insuranceProposals = [];
    }
  }

  private resetInsuranceProposals() {
    this.insuranceProposals = [];
    this.selectedProposal = '';
    this.showInsuranceProposals = false;
    this.selectedProductInsuranceConfig = null;
  }

  // Método de prueba para verificar endpoints manualmente
  async testInsuranceEndpoints() {
    console.log('🧪 Probando endpoints de seguros...');

    try {
      // 1. Verificar configuración del producto SEGUROS_MERCANTIL
      console.log('1️⃣ Verificando configuración de SEGUROS_MERCANTIL...');
      const config = await this._user.getRemanenteNeteo('SEGUROS_MERCANTIL');
      console.log('Configuración recibida:', config);

      // 2. Verificar propuestas para SEGUROS_MERCANTIL
      console.log('2️⃣ Verificando propuestas para SEGUROS_MERCANTIL...');
      const proposals = await this._user.getInsuranceProposals('SEGUROS_MERCANTIL');
      console.log('Propuestas recibidas:', proposals);

    } catch (error) {
      console.error('❌ Error en pruebas:', error);
    }
  }

  private async checkAndLoadInsuranceProposalsForEdit() {
    try {
      console.log('🔄 Cargando configuración para edición del producto:', this.productSelected);
      console.log('📋 Plan actual:', this.plan.params);

      // Obtener la configuración completa del producto para verificar si es de seguros
      const productConfig = await this._user.getRemanenteNeteo(this.productSelected);
      console.log('📋 Configuración del producto en edición:', productConfig);

      if (productConfig && productConfig.insurance && productConfig.insurance.is_insurance_product) {
        console.log('✅ Producto ES de seguros en edición:', productConfig.insurance);
        this.selectedProductInsuranceConfig = productConfig.insurance;
        await this.loadInsuranceProposals(this.productSelected);
        this.showInsuranceProposals = true;
        console.log('✅ Select de propuestas mostrado en edición');

        // Si el plan ya tiene una propuesta seleccionada, restaurarla
        if (this.plan.params.insurance_proposal) {
          console.log('📌 Restaurando propuesta seleccionada:', this.plan.params.insurance_proposal);
          this.selectedProposal = this.plan.params.insurance_proposal;
        }
      } else {
        console.log('❌ Producto NO es de seguros en edición');
        this.resetInsuranceProposals();
      }
    } catch (error) {
      console.error('❌ Error verificando configuración de seguros en edición:', error);
      this.resetInsuranceProposals();
    }
  }

  async consultAllProductsInvoices(){
    try {

      let consultProducts = await this._user.getTypesProductsInvoices();

      this.productArray = consultProducts.resp;


    } catch (error) {
      throw error;
    }
  }

  // Nuevas funciones para Códigos dinámicos2 (other)
  filteredItems4() {
    if (this.filterText4) {
      // Mantener el filtrado por categorías "other" (no "person") y aplicar el filtro de texto
      this.auxList4 = this.dynamicCodeList2.filter((item: any) =>
        item.category !== 'person' && item.code.toLowerCase().includes(this.filterText4.toLowerCase())
      );
    } else {
      // Solo códigos que no son de categoría "person"
      this.auxList4 = this.dynamicCodeList2;
    }
  }

  selectItem4(item: any) {
    this.showListCodes3 = false;
    const found = this.codeList2.find(
      (element: any) =>
        element.code.toString().toLowerCase() ==
        item.code.toString().toLowerCase()
    );

    if (!found) {
      this.codeList2.push(item);
    }
  }

  deletItem4(item: any) {
    this.codeList2.forEach((elemnt: any, index: number) => {
      if (
        elemnt.code.toString().toLowerCase() ==
        item.code.toString().toLowerCase()
      ) {
        this.codeList2.splice(index, 1);
      }
    });
  }

  // Debug method para capturar cambios en el toggle de weekday
  onWeekdayToggleChange(value: boolean) {
    console.log('GEMINI DEBUG: Toggle weekday cambiado a:', value);
    this.plan.params.weekday = value;
    console.log('GEMINI DEBUG: Valor actualizado de plan.params.weekday:', this.plan.params.weekday);
  }

}
const today = new Date();
const DEFAULT_PLAN_DATA: any = {
  visibility: '',
  date: new Date(),
  code: '',
  name: '',
  description: '',
  state: 'INACTIVE',
  status: false,

  initial: {
    status: true,
    type: '',
    amount: 0,
    recalculate: true,
  },
  version: {
    name: '',
    description: '',
  },
  params: {
    min_amount_base: 0,
    max_amount_base: 50,
    current_quota_min: 50,
    current_quota_max: 50,
    min_amount: 0,
    init_date: today.toISOString().split('T')[0],
    client_view: 'true',
    generate_pagares: true,
    generate_pagares_fisico: false,

    weekday: false,
    product_type:'',
    icon: '',
    remanente: {
      status: false,
      amount: 0
    },
    neteo: {
      status: false,
      amount: 0
    },
    multiple_invoices: {
      status: true,
      count: 0,
    },
    filters: {
      general: {
        invoices: {
          //  category: '',
          shop: {
            type: '',
            list: [],
          },
        },
        person: {
          audience: 'NATURAL',
        },
      },
      dinamic_code: {
        person: {
          type: '',
          list: [],
        },
        other: {
          type: '',
          list: [],
        },
      },
    },
    provider: '63dc1737b5e22028eedb051e',
    priority: 0,
  },
  payment_terms: [
    {
      code: '',
      name: '',
      order: 0,
      installments: 1,
      frequency: {
        type: '', // mes, dia, semana, dias continuos
        number: 0, // aca se pasa el numero para saber cada cuantos dias
      },
    },
  ],
  version_change: [],
};

const defaultFilter = {
  general: {
    person: {
      audience: 'NATURAL',
    },
    invoices: {
      shop: {
        type: '',
        list: [],
      },
    },
  },
  dinamic_code: {
    person: {
      type: '',
      list: [],
    },
    other: {
      type: '',
      list: [],
    },
  },
};

const defaultTerms = {
  code: '',
  name: '',
  order: 0,
  installments: 0,
  frequency: {
    type: '', // mes, dia, semana, dias continuos
    number: 0, // aca se pasa el numero para saber cada cuantos dias
  },
};
